function SummaryCard({ label, value }) {
  return (
    <div className="rounded-lg border border-gray-200 dark:border-gray-800 p-4 bg-white dark:bg-gray-900">
      <div className="text-xs text-gray-500">{label}</div>
      <div className="text-xl font-semibold text-gray-900 dark:text-white">
        {value}
      </div>
    </div>
  );
}

export default function LiensSummaryCards({ summary, toMoney }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
      <SummaryCard label="Total liens" value={summary.total} />
      <SummaryCard
        label="Open + Unknown (sum)"
        value={toMoney(summary.openPlusUnknownAmount)}
      />
      <SummaryCard label="Open" value={summary.openCount} />
      <SummaryCard label="Released" value={summary.releasedCount} />
    </div>
  );
}
